const R2_PREFIX = 'https://remotion.media/announcements/whats-new-in-remotion';

export const assetUrl = (filename: string) => `${R2_PREFIX}/${filename}`;
